import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import UpdatePriorityModal from './updatePriorityModal';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'T-Card Priority', path: '/', active: true }
];

const TCardPriority = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedPriorityID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedPriorityID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'tCardPriorityDescription',
            title: `Description`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardPrioritySequence',
            title: `Sequence`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedPriorityID: row ? row.tCardPriorityID : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <abbr title="Add T-Card Priority">
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <abbr title="Edit T-Card Priority">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    const baseUrl = 'TCardPriorities/TCardPriorities_List';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp
                    maxWidth="sm"
                    PaperProps={{ style: { minHeight: '320px', minWidth: '600px' } }}
                    title={state.selectedPriorityID ? 'Update T-Card Priority' : 'Add T-Card Priority'}
                    onClose={() => handleClose(false)}
                >
                    <UpdatePriorityModal onClose={() => handleClose(true)} priorityID={state.selectedPriorityID} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default TCardPriority;
